module.exports = __webpack_public_path__ + "static/media/satellitesmash.a21bcc9f.png";